<h2 mat-dialog-title>{{ dialogTitle() }}</h2>
<mat-divider></mat-divider>
<mat-dialog-content>
    <div class="picker-container">
        <div
            colorPicker
            [cpToggle]="true"
            [cpDialogDisplay]="'inline'"
            [colorPicker]="color()"
            [cpOutputFormat]="'hex'"
            (colorPickerChange)="onColorChange($event)"
        >
        </div>
    </div>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
    <button
        mat-button
        (click)="onCancel()"
    >{{ 'cancel' | transloco }}</button>
    <button
        mat-raised-button
        color="primary"
        (click)="onConfirm()"
    >{{ 'apply' | transloco }}</button>
</mat-dialog-actions>